/**
 * @flow
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteFragment } from 'relay-runtime';
type HeaderHorizontal_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BaseHorizontal_user$ref: FragmentReference;
export type BaseHorizontal_user = {|
  +$fragmentRefs: HeaderHorizontal_user$ref,
  +$refType: BaseHorizontal_user$ref,
|};
*/

const node /*: ConcreteFragment*/ = {
  kind: "Fragment",
  name: "BaseHorizontal_user",
  type: "UserType",
  metadata: null,
  argumentDefinitions: [],
  selections: [
    {
      kind: "FragmentSpread",
      name: "HeaderHorizontal_user",
      args: null,
    },
  ],
};
// prettier-ignore
(node/*: any*/).hash = 'c84afd888668f1d1ff643ca4bfd575ea';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/Layout/__generated__/BaseHorizontal_user.graphql.js